import { useTranslation } from "react-i18next";
import { FormRow } from "../../../../../../../../../style/form";
import { Address } from "../../../../../../../../../redux/apiSpecifications/apiSubjects";
import { InputTextStyled } from "../../../../../../../../../style/Input";
import { toFullAddress } from "../../../../../../../../../utils/address";
import { IconPracticesRejected } from "../../../../../../../../../config/icons";
import styled from "styled-components";
import { IconButtonWithConfirm } from "../../../../../../../../Inputs/IconButtons";
import dekra from "../../../../../../../../../style/dekra";

const PolicySubjectAddressesFormWrapper = styled.div`
  .ant-input[disabled] {
    color: rgba(0, 0, 0, 0.25);
    background-color: rgb(255, 255, 255);
    border-color: #d9d9d9;
    box-shadow: none;
    cursor: not-allowed;
    opacity: 1;
  }

  .edit-allowed {
    cursor: pointer !important;
  }
`;

const PolicySubjectAddressesFormRow = styled(FormRow)`
  .field {
    width: 100%;
  }

  .button {
    // color: red;
    color: ${dekra.primaryColor};
    margin-top: auto;
    margin-bottom: 10px;

    // div {
    //   height: 32px;
    // }
  }
`;

interface IPolicySubjectAddressesFormProps {
  addresses?: Address[] | undefined;
  disableForm?: boolean;
  onEditAddress?: (address: Address) => void;
  onDeleteAddress?: (addressId: number) => void;
}

const PolicySubjectAddressesForm = ({
  addresses = [],
  disableForm,
  onEditAddress,
  onDeleteAddress,
}: IPolicySubjectAddressesFormProps) => {
  const { t } = useTranslation();

  const handleOnEditAddress = (address: Address) => {
    if (onEditAddress) onEditAddress(address);
  };

  const handleOnDeleteAddress = (addressId: number) => {
    if (onDeleteAddress) onDeleteAddress(addressId);
  };

  const homeAddress = addresses.find((_) => _.type === "D");
  const residenceAddress = addresses.find((_) => _.type === "R");
  const registeredOffice = addresses.find((_) => _.type === "L");

  return (
    <PolicySubjectAddressesFormWrapper>
      <PolicySubjectAddressesFormRow>
        <div className="field">
          <InputTextStyled
            classNameInput={disableForm ? "edit-disallowed" : "edit-allowed"}
            label={t("LABELS.home-address")}
            placeholder={t("PLACEHOLDERS.home-address")}
            value={toFullAddress(homeAddress)}
            readOnly={true}
            disabled={disableForm}
            onClick={() => handleOnEditAddress(homeAddress || { type: "D" })}
          />
        </div>

        <div className="button">
          <IconButtonWithConfirm
            onClick={
              homeAddress && disableForm === false
                ? () => handleOnDeleteAddress(homeAddress.id!)
                : undefined
            }
            popconfirmOption={{
              title: t("MESSAGES.confirm-delete-subject-address")!,
              placement: "leftTop",
            }}
          >
            <IconPracticesRejected />
          </IconButtonWithConfirm>
        </div>
      </PolicySubjectAddressesFormRow>

      <PolicySubjectAddressesFormRow>
        <div className="field">
          <InputTextStyled
            classNameInput={disableForm ? "edit-disallowed" : "edit-allowed"}
            label={t("LABELS.residence-address")}
            placeholder={t("PLACEHOLDERS.residence-address")}
            value={toFullAddress(residenceAddress)}
            readOnly={true}
            disabled={disableForm}
            onClick={(e) => {
              handleOnEditAddress(residenceAddress || { type: "R" });
            }}
          />
        </div>

        <div className="button">
          <IconButtonWithConfirm
            onClick={
              residenceAddress && disableForm === false
                ? () => handleOnDeleteAddress(residenceAddress.id!)
                : undefined
            }
            popconfirmOption={{
              title: t("MESSAGES.confirm-delete-subject-address")!,
              placement: "leftTop",
            }}
          >
            <IconPracticesRejected />
          </IconButtonWithConfirm>
        </div>
      </PolicySubjectAddressesFormRow>

      <PolicySubjectAddressesFormRow>
        <div className="field">
          <InputTextStyled
            classNameInput={disableForm ? "edit-disallowed" : "edit-allowed"}
            label={t("LABELS.registered-office-address")}
            placeholder={t("PLACEHOLDERS.registered-office-address")}
            readOnly={true}
            value={toFullAddress(registeredOffice)}
            disabled={disableForm}
            onClick={() =>
              handleOnEditAddress(registeredOffice || { type: "L" })
            }
          />
        </div>

        <div className="button">
          <IconButtonWithConfirm
            onClick={
              registeredOffice && disableForm === false
                ? () => handleOnDeleteAddress(registeredOffice.id!)
                : undefined
            }
            popconfirmOption={{
              title: t("MESSAGES.confirm-delete-subject-address")!,
              placement: "leftTop",
            }}
          >
            <IconPracticesRejected />
          </IconButtonWithConfirm>
        </div>
      </PolicySubjectAddressesFormRow>
    </PolicySubjectAddressesFormWrapper>
  );
};

export default PolicySubjectAddressesForm;
